export const state = {
    user: {
        user: 'SAMUEL SUPER ADMIN'
    },   
}